import { useState, useEffect } from 'react';

import { ImportanceLevel, UNBREAKABLE_LEVEL_VALUE } from './types';
import { getImportanceLevel, getImportanceValue, isUnbreakable } from './utils';
import ImportanceLevelListbox from './ImportanceLevelListbox';
import ImportanceValueInput from './ImportanceValueInput';

interface ImportanceInputProps {
  value: number;
  onChange: (value: number) => void;
  className?: string;
}

export default function ImportanceInput({
  value,
  onChange,
  className = '',
}: ImportanceInputProps) {
  const [inputValue, setInputValue] = useState(value);
  const [listboxValue, setListboxValue] = useState(value);

  // Update internal state when external value changes
  useEffect(() => {
    setInputValue(value);
    setListboxValue(value);
  }, [value]);

  const handleInputChange = (newValue: number) => {
    setInputValue(newValue);
    setListboxValue(newValue);
    onChange(newValue);
  };

  const handleListboxChange = (level: ImportanceLevel) => {
    const newValue = getImportanceValue(level);
    setInputValue(newValue);
    setListboxValue(newValue);
    onChange(newValue);
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <ImportanceValueInput
        value={inputValue}
        onChange={handleInputChange}
        isUnbreakable={isUnbreakable(inputValue)}
      />
      <ImportanceLevelListbox
        value={listboxValue}
        onChange={handleListboxChange}
      />
    </div>
  );
}
